const lessonData = {

  2: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/gettyimages-886134986-640x640.jpg', alt: 'Police and parademics respond to a call', order: 0}
    ],
    layoutNumber: 4,
    navigation: [
      { available_scene: "4", current_scene: "2", previous_scene: "1",text: "Continue" },
    ],
    scene_number: "2",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [``],
    text: [
      `<p>A case study is a story that is used to generate discussion and critical thinking.</p><p>Case studies are realistic. Some are based on true stories, while others are made up, but written in such a way that they could have really happened.</p`
    ],
    title: `What is a case study?`,
    videos: [],
    audio: [],
  },
  
  4: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/pexels-edgard-5628406.jpg', alt: 'You noticed you were waking up feeling awful.', order: 0}
    ],
    layoutNumber: 4,
    navigation: [
      { available_scene: "5", current_scene: "4", previous_scene: "2",text: "Continue" },
    ],
    scene_number: "4",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>Usually, case studies contain complicated situations, where difficult decisions must be made.</p><p>They are very effective tools for practicing applying knowledge to a real-life scenario. Just like real life, there aren’t always clear “right” or “wrong” answers in a case study.</p><p>The complexity of the situation is intentionally thought-provoking, allowing learners to bring their unique perspectives to the situation.</p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  5: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/pexels-tima-miroshnichenko-5711372.jpg', alt: 'Facilitated discussion', order: 0}
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "6", current_scene: "5", previous_scene: "4",text: "Continue" },
    ],
    scene_number: "4",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>Case studies are best used in facilitated group settings, though they can be worked on individually, too.</p><p>The case studies in this series contain parts (A and B, and in one case, C).</p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  6: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/pexels-tima-miroshnichenko-5711372.jpg', alt: 'Facilitated discussion', order: 0}
    ],
    layoutNumber: 4,
    navigation: [
      { available_scene: "7", current_scene: "6", previous_scene: "4",text: "Continue" },
    ],
    scene_number: "4",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>Participants should read through Part A first, which contains the setup for the case and an introduction of the complex scenario, and then stop for reflection.</p><p>In a group setting, a facilitator can ask the group the series of reflection questions which follows Part A. This set of questions focuses on the decision that the characters of the case must make and any complicated dynamics of the case. If the conversation is lively, the facilitator can ask follow-up questions.</p><p>The facilitator should have read through the entire case study and all reflection questions beforehand, to prepare for this session. </p>`,
    ],
    title: `Part A`,
    videos: [],
    audio: [],
  },
  7: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
      {image: 'https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/pexels-tima-miroshnichenko-5711372.jpg', alt: 'Facilitated discussion', order: 0}
    ],
    layoutNumber: 4,
    navigation: [
      { available_scene: "8", current_scene: "7", previous_scene: "4",text: "Continue" },
    ],
    scene_number: "4",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>Once the Part A discussion has ended, participants can read through Part B, which contains additional details about the complex scenario and a resolution of the case.</p><p>The facilitator should then ask the group the series of reflection questions which follows Part B. This set of questions focuses on the impact of the decisions that were made and may ask participants to consider how these choices could be applied to different contexts.</p><p>When working on a case study individually, a learner can answer the reflection questions on their own, usually in writing.</p>`,
    ],
    title: `Part B`,
    videos: [],
    audio: [],
  },
  8: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [],
    layoutNumber: 4,
    navigation: [
      { available_scene: "10", current_scene: "8", previous_scene: "7",text: "Continue" },
    ],
    scene_number: "8",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [`<p>Facilitated case study discussions can be used in a number of settings to promote new ways of thinking, including: </p><ul>
      <li>During team professional development meetings</li><li>During onboarding training for new hires</li><li>To bring together cross-functional team members to solve a problem</li><li>To give team members exposure to a problem that they weren’t previously aware of</li><li>To analyze past situations so that teams can develop better strategies for the future</li><li>To learn about best practices from other fields, industries, or contexts</li></ul>`],
    title: null,
    videos: [],
    audio: [],
  },
 
  10: {
    checkpoint: false,
    last: true,
    checkpoints: [],
    images: [],
    layoutNumber: 6,
    navigation: [{available_scene: "10", current_scene: "10", previous_scene: "11",text: "End Lesson" }],
    scene_number: "10",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>You now know a little bit more about how to use case studies for learning! Explore the case studies we have available on the <a href="https://chaplaincyinnovation.org/training-credentials/case-studies" rel="_blank" ref="noopener noreferrer">Chaplaincy Innovation Lab</a> website to dig in!</p>`
    ],
    title: null,
    videos: [],
    audio: [],
  },
};

export default lessonData;